module.exports = __webpack_public_path__ + "static/media/2021_4G8A8809.92d561c9.jpg";